import { Component } from 'react';
import withAuth from '../../components/withAuth';
import {withStyles} from '@mui/styles';
import {compose} from "redux";
import {connect} from "react-redux";
import AnalyseRisquesTable from "../../components/AnalyseRisques/AnalyseRisquesTable";
import {
    redirect, setEditionState, resetAnalyseRisquesSelection,
    getRiskTypes, getInstructionTypes, getPpeList, getWorkingAccreditations,
    cleanOldAnalyseRisques, initSppStatus
} from "../../redux/analyseRisques/analyseRisquesActions";
import {
    getCompanies
} from "../../redux/companies/companiesActions";
import '../../utils.css';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    bar: {
        backgroundColor: '#F5F6F5',
    },
    table: {
        minWidth: 700,
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
});

class RisksAndPreventionsListTab extends Component {

    constructor(props){
        super(props);
        this.props.resetRedirect();
        this.props.getRiskTypes((riskTypes) => {
            this.props.getPpeList((ppeList) => {
                this.props.resetAnalyseRisquesSelection(props.activeUser, ppeList, riskTypes, props.analyseRisques.header);
            }); 
        }); 
        this.props.getInstructionTypes();                 
        this.props.getWorkingAccreditations();
        this.props.getCompanies(props.activeUser);
    }

    componentWillUnmount(){
        this.props.cleanOldAnalyseRisques(this.props.analysesRisques.moduleSpp, this.props.analysesRisques);
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding analyse-risques-margin container-with-footer">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                    <AnalyseRisquesTable/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        redirectUrl: state.analyseRisques.redirectUrl,
        activeUser: state.activeUser,
        analysesRisques: state.analysesRisques,
        analyseRisques: state.analyseRisques,
        riskTypes: state.riskTypes.types
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetRedirect: () => dispatch(redirect(null)),
        setEditionState: (creationMode, updateMode) => dispatch(setEditionState(creationMode, updateMode)),
        resetAnalyseRisquesSelection: (connectedEmployee, ppeList, riskTypes) => dispatch(resetAnalyseRisquesSelection(connectedEmployee, ppeList, riskTypes)),
        getRiskTypes: (onSuccess) => dispatch(getRiskTypes(onSuccess)),
        getInstructionTypes: () => dispatch(getInstructionTypes()),
        getPpeList: (onSuccess) => dispatch(getPpeList(onSuccess)),
        getWorkingAccreditations: () => dispatch(getWorkingAccreditations()),
        getCompanies: (activeUserId) => dispatch(getCompanies(activeUserId)),
        cleanOldAnalyseRisques: (moduleSpp, analysesRisquesState) => dispatch(cleanOldAnalyseRisques(moduleSpp, analysesRisquesState)),
        initSppStatus: (header) => dispatch(initSppStatus(header)),
    };
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(RisksAndPreventionsListTab);
